@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: relative;
    flex: 1 1 50%;
    aspect-ratio: 2 / 1;
    overflow: hidden;

    &:has(a):not(:has(video)) {
        cursor: pointer;
    }

    @media ($below-mobile) {
        aspect-ratio: 1 / 1;
    }
}

.media {
    position: absolute;
    inset: 0;
    transition: transform 0.4s ease;

    img,
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.root:hover .media,
.root:focus-visible .media {
    transform: scale(1.05);
}

.gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 43%;
    background: linear-gradient(to top, var(--black), transparent);
    pointer-events: none;
    z-index: 1;
}

.text {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacer-8);
    padding: var(--spacer-24) var(--spacer-16);
    text-align: center;
    z-index: 2;

    @media ($below-mobile) {
        gap: var(--spacer-4);
        padding: var(--spacer-16);
    }
}

.eyebrow {
    font: var(--font-eyebrow-12-lg);
    color: var(--off-white);
    text-transform: uppercase;

    @media ($below-mobile) {
        font: var(--font-eyebrow-12-sm);
    }
}

.title {
    font: var(--font-h-24-lg);
    color: var(--off-white);
    text-wrap: balance;

    @media ($below-mobile) {
        font: var(--font-h-24-sm);
    }
}

:export {
    sizes: "50vw";
}
